import { clsxMerge } from '@/app/lib/utils/styles';
import JSLogoIcon from '@/app/ui/assets/icons/js-logo-icon';

export interface Props {
  className?: string;
}

export default function RequireJSLabel({ className }: Props) {
  return (
    <div className={clsxMerge('inline-flex items-start gap-2', className)}>
      <JSLogoIcon className='size-4 rounded-sm' />
      <span className='text-xs font-semibold text-slate-950'>Require&nbsp;JS</span>
    </div>
  );
}
